export const NICE_COMMENT_LENGTH = 50;
export const sameSiteOrigins = ['https://escape.bar', 'https://stg.escape.bar', 'http://localhost:3200'];